/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export class MarketShareSegmentReportRequest {
  userId: string;
  workingScenId: number;
  isGlobal: number;
  selectedRegionFilters: string[];
  selectedSubregionFilters: string[];
  selectedPlngMktFilters: string[];
  selectedArchFilters: string[];
  selectedMktDivFilters: string[];
  selectedLbrandFilters: string[];
  selectedPrgmCodeFilters: string[];
  selectedTosFilters: string[];
  startYear: number;
  endYear: number;
  segLvl: number;
  geography: string;
  vehDetailOutputs: string[];
  isIncludeTos: number;
  combinePhevIce: boolean;
  compareScenId: number;
}
